module.exports = __webpack_public_path__ + "img/starting-table-icon.65a85295.svg";